import React, { useState } from 'react';
import { Field } from 'formik';
import APICall from '../../helpers/api';
import styled from '@emotion/styled';
import P from 'prop-types';
import Progress from './Progress';
import axios from 'axios';
const Upload = props => {
  const { name, label, limitDimensions, S3Bucket, API, data, disabled } = props;
  const [upload, setUpload] = useState(0);
  const [max, setMax] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [error, setError] = useState(null);

  // S3Bucket = bp-ca-artisans
  // API      = artisan/artisan-category-signedurl/
  // data     = {artisanID : 'id'}
  // name     = categoryImage
  // console.log({ S3Bucket }, { API }, { name });

  return (
    <Field name={name}>
      {({ field, form }) => {
        const { setFieldValue } = form;
        const { value } = field;
        let fileName = 'Choose Image';

        const checkWidthAndHeight = file => {
          return new Promise((resolve, reject) => {
            const src = URL.createObjectURL(file);
            const image = new Image();
            image.src = src;
            image.onload = () => {
              if (
                image.width >= limitDimensions.width ||
                image.height >= limitDimensions.height
              ) {
                reject(
                  `limits are ${limitDimensions.width}/${limitDimensions.height}`
                );
              } else {
                resolve('done');
              }
              URL.revokeObjectURL(src);
            };
          });
        };

        const handleUpload = async file => {
          console.log('fillle', file);
          setError(null);

          // ckecking the file type
          if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
            setError('you can only upload photos in png/jpeg format');
            return;
          }
          if (file.size > 1000000) {
            setError('The image is too big!. it must be less than 1 MB');
            return;
          }
          // ckecking the image width and height
          if (limitDimensions) {
            try {
              await checkWidthAndHeight(file);
            } catch (error) {
              setError(error);
              return;
            }
          }

          setFieldValue(field.name, '');

          setUpload(0);
          setMax(0);

          const uploadConfig = await APICall.post(API, data);
          setShowProgress(true);
          try {
            await axios.put(uploadConfig.data.url, file, {
              onUploadProgress: ProgressEvent => {
                setMax(ProgressEvent.total);
                setUpload(ProgressEvent.loaded);
              },
              headers: {
                'Content-Type': file.type
              }
            });

            setFieldValue(
              field.name,
              // `https://${S3Bucket}.s3.amazonaws.com/${uploadConfig.data.key}`
              `https://${S3Bucket}.s3.eu-central-1.amazonaws.com/${uploadConfig.data.key}`
            );
          } catch (error) {
            console.log({ error });
            setError(error.message);
          } finally {
            setShowProgress(false);
          }
        };

        return (
          <div className='form-group '>
            <div className='wrapper'>
              <div className=' file-upload'>
                {/* <input type="file" class="custom-file-input" id="customFile"> */}
                {/* <label class="custom-file-label" for="customFile">Choose file</label> */}

                {/* <label className='col-lg-3 col-form-label' htmlFor={name}> */}

                {/* <FieldContainer className='col-lg-9'> */}
                <input
                  disabled={disabled}
                  multiple={false}
                  id='upload'
                  className='custom-file-input upload-box'
                  type='file'
                  accept='image/png, image/jpeg'
                  onChange={e => {
                    console.log(e.target.files[0], 'filllle');
                    handleUpload(e.target.files[0]);
                  }}
                />
                <i class='fa fa-arrow-up'></i>

                {/* <FileLabel className='custom-file-label'>{fileName}</FileLabel> */}
              </div>
            </div>
            <p className='text-center mt-3' style={{fontSize: '25px', fontWeight: 'bold'}}>{label}</p>
            {error && <TextError className='error'>{error}</TextError>}

            {showProgress && <Progress value={upload} max={max} />}
            {value && (
              <FileList>
                <File target='_blank' rel='noopener noref errer' href={value}>
                  <img
                    src={value}
                    alt='company logo'
                    style={{
                      width: '100%',
                      height: '100%',
                      maxHeight: '400px',
                      objectFit: 'cover'
                      // marginBottom: '5px'
                    }}
                  />
                </File>
                <button
                  disabled={disabled}
                  className='btn btn-sm btn-label-danger'
                  style={{ alignSelf: 'center' }}
                  onClick={e => {
                    e.preventDefault();
                    setFieldValue(field.name, '');
                    setError(null);
                  }}
                >
                  {!disabled && (
                    <i
                      className='flaticon-delete'
                      style={{ marginRight: '0px' }}
                    ></i>
                  )}
                </button>
              </FileList>
            )}
            {/* </FieldContainer> */}
          </div>
        );
      }}
    </Field>
  );
};

Upload.prototype = {
  name: P.string.isRequired,
  S3Bucket: P.string.isRequired,
  API: P.string.isRequired,
  data: P.object.isRequired,
  label: P.string,
  limitDimensions: P.shape({
    width: P.number,
    height: P.number
  })
};

Upload.defaultProps = {
  label: '',
  limitDimensions: null
};

const TextError = styled.span`
  color: red;
`;

const FieldContainer = styled.div`
  position: relative;
  padding-bottom: '15px';
`;

const FileLabel = styled.label`
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin: 5px;
  margin-bottom: 20px;
`;

const File = styled.a`
  width: 100px;
  height: 100px;
  background-color: transparent;
  border: 1px solid #ccccce;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.5s;
  &:hover {
    background-color: #ffef058a;
  }
`;
export default Upload;
